<template>
  <svg width="13" height="10" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 4.20125L3.86277 7L10 1" stroke="#5BD9A4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>

<script>
export default {
name:"CheckedMark"
}
</script>

<style>

</style>